import '@patsnap-ui/icon/assets/solid/SynapseDisease.svg'
import '@patsnap-ui/icon/assets/solid/TickCircle.svg'
import { getLangDegraded } from '@patsnap/synapse_common_utils'
import { sharedCtx } from '@pharmsnap/shared/context'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { TRANSLATIONAL_MEDICINE_LIST_QUERY_KEY } from '@pharmsnap/shared/src/types/translational-medicine'
import { IBaseDiseaseInfo } from '@pharmsnap/shared/types'
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api'
import { BDiseasePopperCard, BEntityTag, GIcon, GLink, GTooltip } from '../..'
import $style from './BDiseaseItem.module.scss'

export const BDiseaseItem = defineComponent({
  name: 'BDiseaseItem',
  props: {
    data: {
      required: true,
      type: Object as PropType<IBaseDiseaseInfo>,
    },
    drug_id: {
      type: String,
    },
    popover: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    tmIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const { data } = toRefs(props)
    const href = computed(() => sharedCtx.router.generatorDiseasePath(data?.value?.disease_id || ''))
    const { locale } = useLocale()
    const name = computed(() => (data.value ? getLangDegraded(data.value, locale.value) : ''))
    const showCoreIcon = computed(() => props.coreIds.includes(data?.value?.disease_id || ''))
    const isTranslationalMedicine = computed(() => ctx.root.$route?.query?.from === TRANSLATIONAL_MEDICINE_LIST_QUERY_KEY)
    const showTmIcon = computed(() => isTranslationalMedicine.value && props.tmIds.includes(data?.value?.disease_id || ''))
    const contentCls = showTmIcon.value ? $style.highlightTm : ''
    return {
      locale,
      href,
      name,
      showCoreIcon,
      showTmIcon,
      contentCls,
    }
  },
  render() {
    const id = this.data.disease_id
    const name = this.name as string
    const href = this.href as string
    const content = this.showTmIcon ? (
      <span class={[this.contentCls, 'max-w-full inline-block']}>
        <BEntityTag data-testid="b-disease-item" title={this.name}>
          {this.showIcon ? <GIcon class="text-text-t2 mr-1 flex-shrink-0" svgName="SolidSynapseDisease" /> : null}
          <GLink data-selection-disabled={this.popover} href={href} name={name}></GLink>
          {this.showCoreIcon && (
            <GTooltip
              class="mr-[-2px]"
              theme="light"
              mode="icon"
              iconSize={20}
              iconName="SolidTickCircle"
              iconClass="text-blue-default"
              content={this.$tc('common.coreEntity')}
            ></GTooltip>
          )}
        </BEntityTag>
      </span>
    ) : (
      <BEntityTag data-testid="b-disease-item" title={this.name}>
        {this.showIcon ? <GIcon class="text-text-t2 mr-1 flex-shrink-0" svgName="SolidSynapseDisease" /> : null}
        <GLink data-selection-disabled={this.popover} href={href} name={name}></GLink>
      </BEntityTag>
    )
    if (id && this.popover) {
      return (
        <BDiseasePopperCard id={id} drug_id={this.drug_id}>
          {content}
        </BDiseasePopperCard>
      )
    }
    return content
  },
})
